import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import PersonalInfo from "./PersonalInfo";
import ProfessionalInfo from "./ProfessionalInfo";
import PrivacySettings from "./PrivacySettings";
import AccountActions from "./AccountActions";

const ProfileSettings = () => {
  const { user } = useAuth();
  const [activeSection, setActiveSection] = useState("personal");
  const [message, setMessage] = useState(null);

  const sections = [
    { id: "personal", name: "Personal Information", icon: "👤" },
    { id: "professional", name: "Professional Info", icon: "💼" },
    { id: "privacy", name: "Privacy Settings", icon: "🔒" },
    { id: "account", name: "Account Actions", icon: "⚙️" },
  ];

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage(null), 5000);
  };

  const renderSectionContent = () => {
    const commonProps = { showMessage, user };

    switch (activeSection) {
      case "personal":
        return <PersonalInfo {...commonProps} />;
      case "professional":
        return <ProfessionalInfo {...commonProps} />;
      case "privacy":
        return <PrivacySettings {...commonProps} />;
      case "account":
        return <AccountActions {...commonProps} />;
      default:
        return <PersonalInfo {...commonProps} />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="border-b border-gray-200 pb-4">
        <h2 className="text-2xl font-bold text-gray-900">Profile Settings</h2>
        <p className="mt-1 text-sm text-gray-600">
          Manage your personal information, privacy settings, and account
          preferences.
        </p>
      </div>

      {/* Message */}
      {message && (
        <div
          className={`p-4 rounded-lg ${
            message.type === "success"
              ? "bg-green-50 text-green-800 border border-green-200"
              : message.type === "error"
                ? "bg-red-50 text-red-800 border border-red-200"
                : "bg-blue-50 text-blue-800 border border-blue-200"
          }`}
        >
          {message.text}
        </div>
      )}

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        {/* Section Navigation */}
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8 px-6">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => setActiveSection(section.id)}
                className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition-colors ${
                  activeSection === section.id
                    ? "border-primary-500 text-primary-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                <span className="text-base">{section.icon}</span>
                <span>{section.name}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Section Content */}
        <div className="p-6">{renderSectionContent()}</div>
      </div>
    </div>
  );
};

export default ProfileSettings;
